import React, { useEffect, useRef, useState } from "react";
import { imgUri } from "../lib/api";

// Homepage rotating photos – admin-managed list. Auto-rotates every 4.5 s, swipeable, dots.
export function HeroCarousel({ images, onClick }) {
  const [idx, setIdx] = useState(0);
  const trackRef = useRef(null);

  useEffect(() => {
    if (!images || images.length < 2) return;
    const id = setInterval(() => setIdx((i) => (i + 1) % images.length), 4500);
    return () => clearInterval(id);
  }, [images]);

  if (!images || !images.length) return null;

  return (
    <div
      data-testid="hero-carousel"
      onClick={onClick}
      className="mt-4 cursor-pointer overflow-hidden rounded-3xl border border-hm-line bg-hm-card"
    >
      <div className="relative h-[180px] w-full sm:h-[220px] lg:h-[300px]">
        {images.map((u, i) => (
          <img
            key={u + i}
            src={imgUri(u)}
            alt=""
            data-testid={`hero-slide-${i}`}
            className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ${i === idx ? "opacity-100" : "opacity-0"}`}
          />
        ))}
        {images.length > 1 ? (
          <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-1.5">
            {images.map((_, i) => (
              <span
                key={i}
                className={`h-[7px] rounded-full bg-white transition-all ${i === idx ? "w-[18px] opacity-100" : "w-[7px] opacity-50"}`}
              />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
